// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
// <graphServiceSnippet1>
import moment from 'moment';
import { PageIterator } from '@microsoft/microsoft-graph-client';
var graph = require('@microsoft/microsoft-graph-client');
function getAuthenticatedClient(accessToken) {
    // Initialize Graph client
    const client = graph.Client.init({
        // Use the provided access token to authenticate
        // requests
        authProvider: (done) => {
            done(null, accessToken);
        }
    });
    return client;
}
export async function getUserDetails(accessToken) {
    const client = getAuthenticatedClient(accessToken);
    const user = await client
        .api('/me')
        //.select('displayName,mail,mailboxSettings,userPrincipalName')
        .select('displayName,mail')
        .get();
    return user;
}
// </graphServiceSnippet1>
// <getUserWeekCalendarSnippet>
export async function getUserWeekCalendar(accessToken, timeZone, startDate) {
    const client = getAuthenticatedClient(accessToken);
    // Generate startDateTime and endDateTime query params
    // to display a 7-day window
    var startDateTime = startDate.format();
    var endDateTime = moment(startDate).add(7, 'day').format();
    // GET /me/calendarview?startDateTime=''&endDateTime=''
    // &$select=subject,organizer,start,end
    // &$orderby=start/dateTime
    // &$top=50
    var response = await client
        .api('/me/calendarview')
        .header('Prefer', `outlook.timezone="${timeZone}"`)
        .query({ startDateTime: startDateTime, endDateTime: endDateTime })
        .select('subject,organizer,start,end')
        .orderby('start/dateTime')
        .top(25)
        .get();
    if (response["@odata.nextLink"]) {
        // Presence of the nextLink property indicates more results are available
        // Use a page iterator to get all results
        var events = [];
        // Must include the time zone header in page
        // requests too
        var options = {
            headers: { 'Prefer': `outlook.timezone="${timeZone}"` }
        };
        var pageIterator = new PageIterator(client, response, (event) => {
            events.push(event);
            return true;
        }, options);
        await pageIterator.iterate();
        return events;
    }
    else {
        return response.value;
    }
}
// </getUserWeekCalendarSnippet>
// <createEventSnippet>
export async function createEvent(accessToken, newEvent) {
    const client = getAuthenticatedClient(accessToken);
    // POST /me/events
    // JSON representation of the new event is sent in the
    // request body
    return await client
        .api('/me/events')
        .post(newEvent);
}
// </createEventSnippet>